import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";

export const Paginator = ({ page, pages, total, pageSize = 50, onPage }) => {
  if (!total) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  return (
    <div className="flex items-center justify-between gap-3 px-1 py-1" data-testid="paginator">
      <p className="text-xs text-muted-foreground">
        Mostrando <b>{start}</b>–<b>{end}</b> de <b>{total}</b>
      </p>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" className="rounded-sm h-8 px-2" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="page-prev">
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="text-xs font-medium px-2 tabular-nums" data-testid="page-indicator">{page} / {pages}</span>
        <Button variant="outline" size="sm" className="rounded-sm h-8 px-2" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="page-next">
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default Paginator;
